import { BaseSpace } from 'app/components/common/BaseSpace'
import { BORDER_RADIUS, PADDING } from 'parkway-web-common'
import styled from 'styled-components'

export const ListWrapper = styled(BaseSpace)`
  background-color: #f3f4f6; // need change
  border-radius: ${BORDER_RADIUS};
  padding: ${PADDING.md};
`
